var _BaseGraphQLGateway_instances, _BaseGraphQLGateway_configureInterceptors;
import { __classPrivateFieldGet } from "tslib";
import { GraphQLClient } from 'graphql-request';
import { BaseGateway } from './BaseGateway';
export class BaseGraphQLGateway extends BaseGateway {
    constructor() {
        super();
        _BaseGraphQLGateway_instances.add(this);
        this.client = new GraphQLClient(this.getEndpoint(), {
            headers: () => __classPrivateFieldGet(this, _BaseGraphQLGateway_instances, "m", _BaseGraphQLGateway_configureInterceptors).call(this),
        });
    }
}
_BaseGraphQLGateway_instances = new WeakSet(), _BaseGraphQLGateway_configureInterceptors = function _BaseGraphQLGateway_configureInterceptors() {
    const headers = {};
    const bearerToken = this.getBearerToken();
    if (bearerToken) {
        headers['authentication'] = `Bearer ${bearerToken}`;
    }
    return Object.assign(Object.assign({}, headers), this.getHeaders());
};
